import * as React from 'react';

import {EpiImage} from "features/search/types";
import {EpiVideo} from 'features/template/types';
import { HeadlineLevel } from 'features/ui/enums';
import {IContentBlock} from 'features/blocks/types';
import {ImageSizes} from '@organisms/Shell/image-size-enum';
import {useDeviceStore, selectIsMobile, selectIsTablet} from 'features/ui/store/useDeviceStore';

import 'components/blocks/Headers/CenterAlignBlock/style.scss';

import {P} from '@atoms/Text/P';
import {Headline} from '@atoms/Text/Headline';
import {Container} from '@atoms/Layout/Container';
import {AsyncImage} from '@atoms/Media/AsyncImage';
import {MovingStill} from '@atoms/Media/MovingStill';

interface CenterAlignBlockType {
    title: string;
    preamble: string;
    heroImage: EpiImage;
    video?: EpiVideo;
}

type Props = IContentBlock<CenterAlignBlockType>;

export const CenterAlignBlock: React.FunctionComponent<Props> = (props) => {

    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);

    return (
        <div className="center-align-block" id={props.id}>
            {props.data.title &&
                <Container intro>
                    <Headline 
                        level={HeadlineLevel.H1} 
                        center 
                    >
                        {props.data.title}
                    </Headline>
                    <P center className="center-align-block__intro" preamble>{props.data.preamble}</P>
                </Container>
            }

            {((props.data.heroImage && props.data.heroImage !== null) || (props.data.video && (!isMobile && !isTablet))) &&
                <div className="center-align-block__media">
                    {(props.data.video && (!isMobile && !isTablet)) 
                        ? <div className="center-align-block__video">
                            <MovingStill
                                srcset={[{src: props.data.video.url, type: "video/mp4"}]}
                                fullWidth
                                playing
                            />
                        </div> 
                        : <div className="center-align-block__image">
                            <div className="center-align-block__image__wrapper">
                                <AsyncImage
                                    image={props.data.heroImage}
                                    headerImage
                                    quality={ImageSizes.SIZE_2560}
                                />
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

